howspace.components = {
    init : async (elem) => {
        real.loop(howspace.components, (component) => {
            if (typeof component.init === 'function') {
                component.init(elem);
            }
        });
    },
    destroy : async (elem) => {
        real.loop(howspace.components, (component) => {
            if (typeof component.destroy === 'function') {
                component.destroy(elem);
            }
        });
    },
    getCallback : (name) => {
        let fn = null;

        // The init function looks something like "howspace.user.initProfileModal". Split that into
        // namespaced parts to turn the string representation into actual function callback.
        const initParts = name.split('.');
        fn = window[initParts.shift()];
        initParts.forEach((part) => {
            fn = fn[part];
        });

        if (typeof fn !== 'function') {
            fn = null;
        }

        return fn;
    }
};
